module.exports = __webpack_public_path__ + "img/login-canelos.07c05c65.svg";